import { render, staticRenderFns } from "./searchTab.vue?vue&type=template&id=5391827f&scoped=true&"
import script from "./searchTab.vue?vue&type=script&lang=js&"
export * from "./searchTab.vue?vue&type=script&lang=js&"
import style0 from "./searchTab.vue?vue&type=style&index=0&id=5391827f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5391827f",
  null
  
)

export default component.exports